module.exports = __webpack_public_path__ + "static/media/IMG_9373.1ff70ba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/IMG_9373.jpg
// module id = 443
// module chunks = 0